import React from 'react';
import { LogisticsObjectDetailPage } from '@/components/common/LogisticsObjectDetailPage';

const ItemDetailPage: React.FC = () => {
  return (
    <LogisticsObjectDetailPage
      config={{
        logisticsObjectType: 'item',
        routeParamKey: 'itemId',
        pageTitle: 'Item Details',
        backRoute: '/items',
        backLabel: 'Back to Items',
        tabIdPrefix: 'item',
        tabsAriaLabel: 'item detail tabs',
        missingIdMessage: 'No item ID provided in the URL.',
        noDataMessage: 'No item data available. The item might not exist or you may not have permission to view it.',
      }}
    />
  );
};

export default ItemDetailPage;